import { getAccessToken } from './authStorage';

/** Adds the persisted localStorage Bearer token to an Axios request. */
export const withLocalStorageAuth = (config = {}, currentToken = null) => {
  const token = typeof currentToken === 'string' && currentToken.trim()
    ? currentToken
    : getAccessToken();
  return {
    ...config,
    withCredentials: false,
    headers: {
      ...(config.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
};